import { useTranslation } from 'react-i18next';
import { Badge } from '@seeqdev/qomponents';

export type SearchGroupHeaderProps = {
  testId?: string;
  showPreviewBadge: boolean;
  showNewBadge: boolean;
  disableSearchGroup: boolean;
  label: string;
  setModeClick?: () => void;
};

type SearchGroupHeaderContentProps = {
  label: string;
  showPreviewBadge: boolean;
  showNewBadge: boolean;
};

const SearchGroupHeaderContent = ({ label, showPreviewBadge, showNewBadge }: SearchGroupHeaderContentProps) => {
  const { t } = useTranslation();
  return (
    <>
      {label}
      {showPreviewBadge ? (
        <Badge testId="preview-badge" variant="preview" extraClassNames="ml7">
          {t('PREVIEW')}
        </Badge>
      ) : null}
      {showNewBadge ? (
        <Badge testId="new-badge" extraClassNames="ml7">
          {t('HOME_SCREEN.NEW')}
        </Badge>
      ) : null}
    </>
  );
};

export const SearchGroupHeader = ({
  testId,
  showPreviewBadge,
  showNewBadge,
  disableSearchGroup,
  label,
  setModeClick,
}: SearchGroupHeaderProps) => {
  return (
    <span data-testid={testId} className={disableSearchGroup ? 'tw:opacity-44' : ''}>
      {setModeClick ? (
        <button
          type="button"
          disabled={disableSearchGroup}
          onClick={setModeClick}
          className="tw:cursor-pointer tw:appearance-none tw:border-0 tw:bg-transparent tw:p-0 tw:text-left tw:disabled:cursor-default">
          <SearchGroupHeaderContent label={label} showPreviewBadge={showPreviewBadge} showNewBadge={showNewBadge} />
        </button>
      ) : (
        <span>
          <SearchGroupHeaderContent label={label} showPreviewBadge={showPreviewBadge} showNewBadge={showNewBadge} />
        </span>
      )}
    </span>
  );
};
